//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminIncorporationController_updateOneById,
  Response$AdminIncorporationController_updateOneById$Status$200,
  ResponseContentType$AdminIncorporationController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminIncorporationController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminIncorporationController_updateOneById,
    Response$AdminIncorporationController_updateOneById$Status$200[ResponseContentType$AdminIncorporationController_updateOneById]
  >({ method: 'AdminIncorporationController_updateOneById' });
